// extracted by mini-css-extract-plugin
module.exports = {"material":"R_NZLYlg","bg":"xfCqqy_4","wrapper":"OKOB3bwI","item":"x849LGk3"};